<template>
  <div class="p-field p-col-9 p-sm-12 p-lg-3">
    <AppFormItem label="Veterinário">
      <AutocompleteApi
        idField="vetAccountId"
        :value="vet"
        :valueId="vetId"
        :search="fetchVets"
        @update:value="$emit('update:vet', $event)"
        @update:valueId="$emit('update:vetId', $event)"
        :disabled="disabled"
      ></AutocompleteApi>
    </AppFormItem>
  </div>
</template>

<script>
import AutocompleteApi from '../../../components/AutocompleteApi.vue';
import { VetApi } from '../../../services/api';

export default {
  name: 'ServiceEditVet',
  components: {
    AutocompleteApi,
  },
  props: {
    vet: Object,
    vetId: Number,
    disabled: Boolean,
  },
  methods: {
    fetchVets: async (query) => {
      const response = await VetApi.fetch(query);
      response.results = response.results.map((result) => ({
        ...result,
        name: result.vetAccount.name,
      }));
      return response;
    },
  },
};
</script>

<style>
</style>
